import { Flex, Switch, Text } from '@chakra-ui/react';
import React, { memo, useEffect } from 'react';
import { UseCaseGeneralDTO } from 'src/api';
import { KeysWithValuesOfType } from 'src/types';
import { useGeneralUpdateField } from '../../useUpdateField';

const STRING_TRUE = 'ja';
const STRING_FALSE = 'nein';

const stringifyBoolean = (value: boolean) => {
  return value ? STRING_TRUE : STRING_FALSE;
};

export const GeneralSwitchInput = memo(function GeneralSwitchInput({
  field,
  title,
  onChange,
  isDisabled,
  dependentValue,
}: {
  field: KeysWithValuesOfType<UseCaseGeneralDTO, string | boolean>;
  title?: string;
  onChange?: (value: boolean) => void;
  isDisabled?: boolean;
  dependentValue?: boolean;
}) {
  const { value, update, readOnly } = useGeneralUpdateField(field);

  const isString = typeof value === 'string';

  const isChecked = isString ? value === STRING_TRUE : value;

  useEffect(() => {
    if (onChange) {
      onChange(isChecked);
    }
    if (dependentValue === false) {
      update(false);
    }
  }, [isChecked, onChange, dependentValue]);

  return (
    <Flex justifyContent="space-between" alignItems="center" mt={6}>
      {title && <Text>{title}</Text>}
      {!readOnly && (
        <Switch
          size="lg"
          isChecked={isChecked}
          isDisabled={isDisabled}
          onChange={e => update(isString ? stringifyBoolean(e.target.checked) : e.target.checked)}
        />
      )}
    </Flex>
  );
});
